import {AfterViewInit, Component, EventEmitter, Input, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {ReplaySubject} from "rxjs";
import {distinct, filter, map, pairwise, throttleTime} from "rxjs/operators";
import {ReportService} from "../../../service/report.service";
import {RecentSearch} from "../../../model/RecentSearch";


@Component({
  selector: 'app-recent-searches',
  templateUrl: './recent-searches.component.html',
  styleUrls: ['./recent-searches.component.scss']
})
export class RecentSearchesComponent implements OnInit, AfterViewInit {

  recentSearches: Array<RecentSearch> = [];

  private searchResultsOffset = 0;

  private pageSize = 20;

  private searchMoreAvailable = true;
  searchLoading: boolean;

  @ViewChild('searchScroller') searchScroller: CdkVirtualScrollViewport;

  @Output()
  onSearchClick = new EventEmitter<RecentSearch>();

  @Input()
  updateSearches$ = new ReplaySubject<boolean>(1);


  constructor(
    private reportService: ReportService,
    private ngZone: NgZone) {
  }

  ngOnInit(): void {
    this.loadMoreSearches(true);
  }

  loadMoreSearches(firstHit = false): void {
    if (firstHit) {
      this.searchMoreAvailable = true;
      this.searchResultsOffset = 0;
      this.recentSearches = [];
    }
    if (this.searchMoreAvailable && !this.searchLoading) {
      this.searchLoading = true;
      const pageNum = Math.ceil(this.searchResultsOffset / this.pageSize) + 1;
      this.reportService.getRecentSearches(this.pageSize, pageNum).subscribe({
        next: response => {
          this.recentSearches = this.recentSearches.concat(response);
          this.searchResultsOffset += response.length;
          if (response.length < this.pageSize) {
            this.searchMoreAvailable = false;
          }
          this.searchLoading = false;
        }, error: error => {
          this.searchLoading = false;
        }
      });
    }
  }

  ngAfterViewInit(): void {
    this.searchScroller.elementScrolled().pipe(
      map(() => this.searchScroller.measureScrollOffset('bottom')),
      pairwise(),
      filter(([y1, y2]) => (y2 < y1 && y2 < 50)),
      throttleTime(100),
      distinct()
    ).subscribe(() => {
      this.ngZone.run(() => {
        this.loadMoreSearches();
      })
    });
    this.updateSearches$.subscribe({
      next: update => {
        this.loadMoreSearches(true);
      }
    });
  }

  onSearchItemClick(search: RecentSearch) {
    this.onSearchClick.emit(search);
  }

  getTooltip(search: RecentSearch): string {
    const stateText = search.state && search.state.stateAbbr ? 'State: ' + search.state.stateAbbr : '';
    const keywordsText = search.keywords ? 'Keywords: ' + search.keywords : '';
    const cusipText = 'CUSIP: ' + search.cusip;

    return [stateText, keywordsText].filter(Boolean).join('\n') || cusipText;
  }
}
